import { FEATURE_IDS, getFeatureUpgradeMessage } from '@/config/features'
import { useNavigate } from 'react-router-dom'

type FeatureId = (typeof FEATURE_IDS)[keyof typeof FEATURE_IDS]

interface UseFeatureAccessResult {
    isEnabled: boolean
    limit: number | null
    shouldShowUpgradePrompt: boolean
    upgradeMessage: {
        title: string
        description: string
        upgradeButtonText: string
    } | null
    handleUpgrade: () => void
}

export const useFeatureAccess = (
    featureId: FeatureId
): UseFeatureAccessResult => {
    const navigate = useNavigate()

    // BYPASS: Always grant access to all features for dev
    const isEnabled = true
    const limit = null // null = unlimited
    const showUpgradePrompt = false
    const upgradeMessage = null

    const handleUpgrade = () => {
        navigate('/billing-plans')
    }

    return {
        isEnabled,
        limit,
        shouldShowUpgradePrompt: showUpgradePrompt,
        upgradeMessage,
        handleUpgrade,
    }
}
